import { Model } from '../typings';

export const createModel = <S>(model: Model<S>) => model;